import { render, staticRenderFns } from "./BoardCard.vue?vue&type=template&id=a43130ca&"
import script from "./BoardCard.vue?vue&type=script&lang=js&"
export * from "./BoardCard.vue?vue&type=script&lang=js&"
import style0 from "./BoardCard.vue?vue&type=style&index=0&id=a43130ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports